export default "__VITE_ASSET__B7CdNZ$e__"